var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-capitalize",attrs:{"small":"","loading":_vm.loading},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Auto Email")])
}
var staticRenderFns = []

export { render, staticRenderFns }